import { defineStore } from 'pinia';
import { IObjStrNumObj } from '@/utils/http';

export const useMyRegister = defineStore('myRegister', () => {
  const channelInfo = reactive<{ [propName: string]: string | number | object }>({});
  function changeChannelInfo(val: IObjStrNumObj) {
    Object.assign(channelInfo, val);
  }
  return {
    channelInfo,
    changeChannelInfo,
  };
});
